export default "__VITE_ASSET__d107f10a__"